import { type VariantProps, cva } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

export { default as Badge } from './Badge.vue';

export interface BadgeProps {
	variant?: BadgeVariants['variant'];
	class?: HTMLAttributes['class'];
}

export const badgeVariants = cva(
	'inline-flex size-full items-center justify-center border px-[8px] py-[6px] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
	{
		variants: {
			variant: {
				primary: 'border border-primary bg-primary text-white',
				'primary-outline': 'border-primary bg-transparent text-primary',
				secondary:
					'border border-primary-light-1 bg-primary-light-1 text-white',
				'secondary-outline':
					'border border-primary-light-1 bg-transparent text-primary-light-1',
				'secondary-dark': 'border-none bg-secondary-dark-1 text-primary',
				tertiary: 'border border-secondary bg-secondary text-primary',
				'tertiary-outline':
					'border border-secondary bg-transparent text-primary',
				brown: 'border border-brown-light-2 bg-brown-light-2 text-white',
				'brown-outline':
					'border border-brown-light-2 bg-transparent text-white',
				white: 'border border-white bg-white text-primary',
				'white-outline': 'border border-white bg-transparent text-white',
				beige: 'border border-beige-dark-2 bg-beige-dark-2 text-primary',
				'beige-outline': 'border border-beige-dark-2 bg-transparent text-beige',
				'beige-default': 'border border-beige bg-beige text-primary',
				blue: 'border border-blue-dark-2 bg-blue-dark-2 text-white',
				'blue-outline':
					'border border-blue-dark-2 bg-transparent text-blue-dark-2',
				success: 'border border-success-dark-1 bg-success-dark-1 text-white',
				'success-outline':
					'border border-success-dark-1 bg-transparent text-success-dark-1',
				alert: 'border border-warning-dark-2 bg-warning-dark-2 text-white',
				'alert-outline':
					'border border-warning-dark-2 bg-transparent text-warning-dark-2',
				error: 'border border-error-dark-1 bg-error-dark-1 text-white',
				'error-outline':
					'border border-error-dark-1 bg-transparent text-error-dark-1'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
